import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import ResponseError from "#/types/responseError"
import { DirectPayPrimaryService } from "#/lib/carrot-api/types/DirectPayPrimaryService"

export function useDirectPayPrimaryServices(
  options?: Pick<UseQueryOptions<DirectPayPrimaryService[], ResponseError>, "enabled">
): UseQueryResult<DirectPayPrimaryService[], ResponseError> {
  return useQuery<DirectPayPrimaryService[], ResponseError>({
    queryKey: ["directPayPrimaryServices"],
    queryFn: () => carrotClient.getDirectPayPrimaryServices(),
    retry: buildCarrotApiRetryPolicy(3),
    // Preloaded on Your Funds; staying fresh lets the dialog reuse it.
    staleTime: 5 * 60 * 1000,
    ...(options ?? {})
  })
}
